(function() {

  // ─── Checkout Intercept ───────────────────────────────────────────────────
  // Uses capture phase so it fires before Emerge's own click handlers
  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('button[name="checkout"], .cart__checkout-button, a[href="/checkout"]');
    if (!btn) return;

    let cart;
    try {
      const res = await fetch('/cart.js');
      cart = await res.json();
    } catch(err) {
      return; // Fail open — don't block checkout if fetch fails
    }

    if (!cart.items.length) return;

    const hasNonAddon = cart.items.some(
      item => item.properties?._is_addon !== 'true'
    );
    if (hasNonAddon) return; // Cart is fine, let Emerge handle it normally

    e.preventDefault();
    e.stopImmediatePropagation();
    showAddonWarning(btn);

  }, true); // <-- capture: true is important


  // ─── Real-time button disable via cart:change ─────────────────────────────
  document.addEventListener('cart:change', function(e) {
    const cart = e.detail.cart;
    if (!cart || !cart.items) return;

    const addonOnly = cart.items.length > 0 && cart.items.every(
      item => item.properties?._is_addon === 'true'
    );

    const checkoutBtn = document.querySelector(
      'button[name="checkout"], .cart__checkout-button'
    );
    if (!checkoutBtn) return;

    if (addonOnly) {
      checkoutBtn.setAttribute('disabled', 'disabled');
      checkoutBtn.style.opacity = '0.5';
      checkoutBtn.style.pointerEvents = 'none';
      showAddonWarning(checkoutBtn);
    } else {
      checkoutBtn.removeAttribute('disabled');
      checkoutBtn.style.opacity = '';
      checkoutBtn.style.pointerEvents = '';
      removeAddonWarning();
    }
  });


  // ─── Helpers ──────────────────────────────────────────────────────────────
  function showAddonWarning(referenceEl) {
    if (document.getElementById('addon-warning')) return;
    const msg = document.createElement('p');
    msg.id = 'addon-warning';
    msg.textContent = 'Add-on items cannot be purchased on their own. Please add a qualifying product to your cart.';
    Object.assign(msg.style, {
      color: '#c0392b',
      fontSize: '0.875rem',
      marginTop: '10px',
      textAlign: 'center'
    });
    referenceEl.parentNode.insertBefore(msg, referenceEl.nextSibling);
  }

  function removeAddonWarning() {
    const msg = document.getElementById('addon-warning');
    if (msg) msg.remove();
  }

})();